<template>

    <div class="modal is-active"  >
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                &nbsp;
                <figure class="image is-64x64" v-if="avartar">
                    <img    :src="avartar" alt="Image">
                </figure> &nbsp; Login By &nbsp; <span class="tag "  style="color: teal">{{getNameAndSurname}} </span>
            </header>
            <section class="modal-card-body">
                <!--                  content-->

<!--                {{user_role}}-->
                <b-table
                        :data="isEmpty ? [] : user_role"
                        bordered
                        striped
                        narrowed
                        hoverable
                        focusable
                        mobile-cards>


                        <b-table-column  label="Your Role"  v-slot="props">
                             {{ props.row.name }}
                        </b-table-column>
                        <b-table-column  label="Your Role"  >
                            <b-icon
                                    icon="check"
                                    size="is-medium"
                                    type="is-danger">
                            </b-icon>
                        </b-table-column>



                    <template slot="empty">
                        <section class="section">
                            <div class="content has-text-grey has-text-centered">
                                <p>
                                    <b-icon
                                            icon="emoticon-sad"
                                            size="is-large">
                                    </b-icon>
                                </p>
                                <p>Nothing here.</p>
                            </div>
                        </section>
                    </template>
                </b-table>




            </section>
            <footer class="modal-card-foot">
                <button class="button is-success"   @click="close" >Close</button>

            </footer>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "ShowUserRole",
        computed:{
            ...mapState({
                user_role : state => state.master_data.user_role,
                avartar : state => state.master_data.avartar,
            }),
            getNameAndSurname(){
                return localStorage.getItem('user_name_surname')
            }
        },
        methods:{
            close(){
              this.$emit('close')
            },

        },
        data(){
            return {
             isComponentModalActive : false,
             isEmpty : false
            }
        }
    }
</script>

<style scoped>

</style>